import { BasicUser } from './basicUser.model';


export class Attachment {
  id: number;
  textContentContainerId: number;
  fileName: string;
  description: string;
  fileReference: string;
  fileType?: {className: string, color: string};
  createdBy?: BasicUser;
  created?: string;

  constructor(id?: number) {
    this.id = id;
  }
}
